import { jsx as _jsx } from "react/jsx-runtime";
import { StudyManagerBannerParent } from "./StudyManagerCommonComponents.styles";
import * as React from "react";
import { observer } from "mobx-react";
import { HXDesktopBanner } from "./HXDesktopBanner";
import NotStarted from "@mui/icons-material/NotStarted";
import Edit from "@mui/icons-material/Edit";
export const StudyManagerRecruitmentPausedBanner = observer((props) => {
    const { onClick } = props;
    return (_jsx(StudyManagerBannerParent, { children: _jsx(HXDesktopBanner, { type: "NORMAL", hideBorder: true, buttonText: "Resume project", buttonIcon: _jsx(NotStarted, {}), onClick: () => onClick(), children: "This project is paused. You cannot manage patients or add new patients until it is resumed." }) }));
});
export const StudyManagerUnpublishedChangesBanner = observer((props) => {
    const { onClick } = props;
    return (_jsx(StudyManagerBannerParent, { children: _jsx(HXDesktopBanner, { type: "NORMAL", hideBorder: true, buttonText: "Edit", buttonIcon: _jsx(Edit, {}), onClick: () => onClick(), children: "This project has unpublished changes. You can review or continue editing the current draft." }) }));
});
